import { render } from "./AdminBookings.vue?vue&type=template&id=6f3c7abe&scoped=true"
import script from "./AdminBookings.vue?vue&type=script&lang=js"
export * from "./AdminBookings.vue?vue&type=script&lang=js"

import "./AdminBookings.vue?vue&type=style&index=0&id=6f3c7abe&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3c7abe"]])

export default __exports__